import { useEffect } from 'react'

import { Button } from '@/legacy/components/Button'
import { Icon } from '@/legacy/components/Icon'
import RadioButton from '@/legacy/components/RadioButton'
import { BodyM } from '@/legacy/components/Typography'

import { usePartnerSearch } from '../core/PartnerSearchContext'
import { OrderOptionStyle } from '../styles'
import { order, type OrderKeys } from '../types'

const OrderPartners = () => {
  const { toggleExpansion, checkedValue, divRef, expanded, handleOptionChange } = usePartnerSearch()
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (divRef.current !== null && !divRef.current.contains(event.target as Node)) {
        toggleExpansion()
      }
    }
    if (expanded) {
      window.addEventListener('click', handleClickOutside)
    }
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [expanded, toggleExpansion, divRef])

  return (
    <OrderOptionStyle ref={divRef}>
      <Button
        aria-label="Ordenar parceiros"
        role="combobox"
        aria-expanded={expanded}
        aria-controls="select-dropdown"
        onClick={toggleExpansion}
        modifier={'solid-invert'}
      >
        <BodyM tag="div" emphasys className="selector-order">
          Ordenar por: <span className="et-text-primary">{checkedValue}</span>
          <Icon className="angle-left et-text-primary" color="accent" icon="angle-left" />
        </BodyM>
      </Button>
      {expanded && (
        <fieldset id="select-dropdown" role="radiogroup" tabIndex={-1}>
          {(Object.keys(order) as OrderKeys[]).map((key: OrderKeys) => {
            const partnerValidation = checkedValue === order[key]

            return (
              <RadioButton
                key={key}
                name="order"
                checked={partnerValidation}
                defaultChecked={partnerValidation}
                value={order[key]}
                label={order[key]}
                aria-label={`Ordenar por ${order[key]}`}
                onClick={handleOptionChange}
                onKeyPress={handleOptionChange}
              />
            )
          })}
        </fieldset>
      )}
    </OrderOptionStyle>
  )
}
export default OrderPartners
